import { Message } from "element-ui";
import swal from "sweetalert2";
import Vue from "vue";

const vm = new Vue();

const prefix = process.env.VUE_APP_URL + "/api/v2";

function parseJWT(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join(""),
    );

    return JSON.parse(jsonPayload);
}

function storeAuthToken(token) {
    localStorage.setItem("auth_token", token);
    const user = parseJWT(token);
    localStorage.setItem("user_role", user.role);
}

function errorAlert(error) {
    const normalized = normalizeError(error);
    const message = getErrorsFormattedAsHTML(normalized);
    swal({
        title: "Error!",
        html: message,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-danger btn-fill",
        type: "error",
    });
}

function normalizeError(error) {
    if (error instanceof Error) {
        if (error.data) {
            return error.data;
        }
        return { message: error.message };
    }

    if (typeof error === "object") return error;

    return { message: String(error) };
}

function getErrorsFormattedAsHTML(error) {
    if (error.message) {
        return error.message;
    }

    if (typeof error === "object") {
        const errors = [];
        for (let k in error) {
            const msg = error[k];
            if (typeof msg === "object") {
                if (msg && Object.keys(msg).length > 0) {
                    errors.push(msg);
                }
            } else {
                errors.push(msg);
            }
        }
        return errors.join("<br/>");
    }

    return "Unknown error";
}

async function handleResponse(endpoint, response, successMessage = "") {
    // don't logout if already requesting from the login page
    // this could be a mistyped username/password
    if (response.status === 401 && endpoint.indexOf("/login") == -1) {
        logout();
        return null;
    }

    const contentType = response.headers.get("content-type");
    const isJson = contentType && contentType.includes("application/json");

    const data = isJson ? await response.json() : null;

    if (!response.ok) {
        let message;

        if (response.status === 500) {
            message = "Internal server error. Please try again later.";
        } else if (data?.message) {
            message = data.message;
        } else {
            message = `HTTP ${response.status}`;
        }

        const error = new Error(message);
        error.response = response;
        error.data = data;

        errorAlert(error);
        throw error;
    }

    if (successMessage) {
        Message({ message: successMessage, type: "success" });
    }

    return data;
}

async function request(
    endpoint,
    { method = "GET", body = null, successMessage = "" } = {},
) {
    const token = localStorage.getItem("auth_token");
    const headers = { Authorization: `Bearer ${token}` };
    const url = prefix + endpoint;

    const response = await vm.$loader(() =>
        fetch(url, {
            method,
            headers: {
                "Content-Type": "application/json",
                ...headers,
            },
            body: body ? JSON.stringify(body) : undefined,
        }),
    );

    return handleResponse(endpoint, response, successMessage);
}

function logout(redirect = true) {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user_role");
    // TODO: remove this only temporary while we transition from auth-token to auth_token
    localStorage.removeItem("auth-token");
    if (redirect) {
        window.location = "/login";
    }
}

// Convenience wrappers
const get = (endpoint) => request(endpoint);
const post = (endpoint, body, successMessage = "Resource created") =>
    request(endpoint, { method: "POST", body, successMessage });
const patch = (endpoint, body, successMessage = "Resource updated") =>
    request(endpoint, { method: "PATCH", body, successMessage });

export default { get, post, patch, logout, storeAuthToken };
